// extracted by mini-css-extract-plugin
export default {"main":"CompactVideoList_main__roemV","videoCard":"CompactVideoList_videoCard__zZCdk"};